import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { MobileSecurityCompanyGridController } from '../controller/MobileSecurityCompanyGridController';

export class MobileSecurityCompanyGridWebComponent extends BaseWebComponentElement {
  public controller: MobileSecurityCompanyGridController;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: MobileSecurityCompanyGridController,
    });
  }
}
